// Growem — temporary "coming soon" gate for sections under construction (Bitácora, Growy).
// Product call (Sebastian, 2026-07-31): hide these while they get polished for multi-user; the
// underlying screens/data stay intact, this is render-only. Revert = swap the tab back in App.tsx.

export default function ComingSoon({ title, desc }: { title: string; desc: string }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', textAlign: 'center', padding: 24 }}>
      <div className="disp" style={{ fontWeight: 700, fontSize: 34, opacity: 0.9 }}>
        {title}<span style={{ color: 'var(--volt)' }}>.</span>
      </div>
      <div className="kick" style={{ marginTop: 14 }}>muy pronto</div>
      <p className="tip" style={{ marginTop: 10, maxWidth: 300 }}>{desc}</p>
      <p className="muted" style={{ fontSize: 12.5, marginTop: 16 }}>Estamos puliendo esta sección. Tu información no se pierde: todo lo que registras queda guardado.</p>
    </div>
  )
}
